// eslint-disable-next-line no-template-curly-in-string
export const companyWildcard = '{{company}}';
export const escapedCompanyWildcard = '\\{\\{company\\}\\}';
